import { Paging } from '@emi/shared/constants';
import { Category, Filters } from '@emi/shared/models';

export default function createFilterDto({
    filterState,
    searchText = '',
    pageId,
    searchTerm = '',
}: {
    filterState: Filters;
    searchText?: string;
    pageId?: string;
    searchTerm?: string;
}): object {
    const countryIds: number[] = [];
    const categoryIds: number[] = [];
    const supplierIds: number[] = [];
    const brandIds: number[] = [];
    const subBrandIds: number[] = [];
    const attributeIds: number[] = [];
    const attributeGroupIds: number[] = [];
    const retailerIds: number[] = [];
    const retailerTypeIds: number[] = [];
    const promotionIds: number[] = [];

    filterState.countries.forEach((country) => countryIds.push(country.id));
    getSelectedCategories(filterState.categories);
    filterState.suppliers.forEach((supplier) => supplierIds.push(supplier.id));
    filterState.brands.forEach((brand) => {
        brand.subBrands?.forEach((subBrand) => subBrandIds.push(subBrand.subBrandId));
        brandIds.push(brand.brandId);
    });
    filterState.attributes.forEach((attribute) => attributeIds.push(attribute.id));
    filterState.attributeTypes.forEach((attributeType) => attributeGroupIds.push(attributeType.id));
    filterState.retailers.forEach((retailer) => retailerIds.push(retailer.id));
    filterState.retailerTypes.forEach((retailerType) => retailerTypeIds.push(retailerType.id));
    filterState.promotions.forEach((promotion) => promotionIds.push(promotion.id));

    function getSelectedCategories(categoryTree: Array<Category>, selectedCategories: Array<Category> = []): void {
        for (const category of categoryTree) {
            if (!category.childCategories || category.childCategories.length === 0) {
                categoryIds.push(category.id);
            } else {
                getSelectedCategories(category.childCategories, selectedCategories);
            }
        }
    }

    const data = {
        searchType: 'all',
        searchDimensionTextFilter: searchText,
        searchPhrase: searchTerm,
        filters: {
            countryIds,
            categoryIds,
            supplierIds,
            brandIds,
            subBrandIds,
            attributeIds,
            attributeGroupIds,
            retailerIds,
            retailerTypeIds,
            promotionIds,
        },
        resultsPerPage: Paging.PAGE_SIZE,
        pageId: pageId,
    };

    return data;
}
